<div class="evaluation-list thin-scrollbar">
  @for (eval of paginatedEvaluations(); track eval.idEvaluation) {
  <mat-card appearance="outlined" class="card-evaluation"
    [ngClass]="{ 'card-leave': leavingEvaluations.has(eval.idEvaluation) }" [routerLink]="'edit/'+eval.idEvaluation">
    <mat-card-header>
      <div mat-card-avatar>
        @if(eval.examen){
        <app-icon type="do" icon="groupe-commission" style="margin-right: 10px;" />
        }@else {
        <app-icon type="do" icon="evaluation" style="margin-right: 10px;" />
        }
        <div>N°{{ eval.numEvaluation }}</div>
      </div>

      <mat-card-title>
        <span>{{ eval.libelle }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="fx-flex-1">
      <!-- <div>
        <label>N° : </label> {{ eval.numEvaluation }}
      </div> -->
      <div>
        <!-- <label>Date : </label> -->
        <app-icon type="do" icon="date-range" style="margin-right: 5px;" />
        @if (eval.dateDebut === eval.dateFin) {
        {{eval.dateDebut | date:'shortDate'}}
        }@else{
        Du {{eval.dateDebut | date:'shortDate'}} au {{eval.dateFin |
        date:'shortDate'}}
        }
      </div>
      <div>
        <!-- <label>Département : </label> -->
        <app-icon type="do" icon="departement" style="margin-right: 5px;" />
        {{ eval.departement }}
      </div>
      @if (eval.discipline) {
      <div>
        <app-icon type="do" icon="discipline" style="margin-right: 5px;" />
        <!-- <label>Discipline : </label> -->
        {{eval.discipline.libelle}}
      </div>
      }
      @if (eval.cours) {
      <div>
        <!-- <label>Cours : </label> -->
        <app-icon type="do" icon="cours" style="margin-right: 5px;" />
        {{eval.cours.libelle}}
      </div>
      }
    </mat-card-content>
    <!-- <mat-card-actions align="end">
      <button mat-stroked-button color="accent" [routerLink]="'edit/'+eval.idEvaluation"
        aria-label="Modifier"><mat-icon>edit</mat-icon>Modifier</button>
      <button mat-stroked-button color="warn" aria-label="Supprimer"
        (click)="confirmDelete(eval)"><mat-icon>delete</mat-icon>Supprimer</button>
    </mat-card-actions> -->
  </mat-card>
  }
</div>
<mat-divider></mat-divider>
<mat-paginator style="border-radius: 4px;" [length]="totalItems()" [pageIndex]="pageIndex()" [pageSize]="pageSize()"
  [pageSizeOptions]="pageSizeOptions()" (page)="onPageChange($event)">
</mat-paginator>